import { Expose, Type } from 'class-transformer';
import { Model } from '@shared/models/model';
import { AvlDeviceAttributes } from './avl-device-attributes.model';

export class AvlDevicePosition extends Model {
  @Expose() id: number;
  @Expose() devicId: number;
  @Expose() address: number;
  @Expose() altitude: number;
  @Expose() course: number;
  @Expose() deviceId: number;
  @Expose() deviceTime: string;
  @Expose() fixTime: string;
  @Expose() latitude: number;
  @Expose() longitude: number;
  @Expose() network: number;
  @Expose() outdated: boolean;
  @Expose() protocol: string;
  @Expose() serverTime: string;
  @Expose() speed: number;
  @Expose() valid: boolean;
  @Expose() selected: boolean;
  @Expose() accuracy: string;

  @Type(() => AvlDeviceAttributes)
  @Expose()
  attributes: AvlDeviceAttributes = new AvlDeviceAttributes();

  constructor() {
    super();
  }
}
